/* global CONFIG */
import moment from 'moment'
import featureToggle from '@/modules/api/featureToggle'

export default {
  getQuote2 (VueApp, params, callback) {
    let self = this
    let rsvpStore = VueApp.$store.state.reservation
    let rsvpLeg = rsvpStore[params.leg]
    let mtechStore = rsvpStore.mtech

    if (!Object.keys(params.pickup).length || !Object.keys(params.dropoff).length) return

    if (params.leg === 'leg1' && rsvpLeg.isAsap) params.asap = true
    params.pickupTime = moment().format('HH:mm:ss')
    if (params.asap) {
      params.pickupDate = moment().format('YYYY-MM-DD')
    }
    if (!rsvpLeg.isAsap && !params.isCharter) {
      // params.asap = rsvpLeg.pickupDate === ''
      if (!rsvpLeg.pickupDate) {
        params.pickupDate = moment().format('YYYY-MM-DD')
      }
    }
    if (!params.asap && rsvpLeg.pickupDate && !params.isCharter) {
      let time = moment(rsvpLeg.pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(VueApp, false))
      params.pickupTime = time.format('HH:mm:ss')
    }
    let quoteUrl = params.isCharter ? '/quotation/charter' : '/quotation'
    if (params.asap) quoteUrl = '/quotation/asap'

    // Mtech adds
    if (!params.isCharter) {
      params.pickup.text = rsvpLeg.pickup.title
      params.dropoff.text = rsvpLeg.dropoff.title
      params.passengers = rsvpLeg.passenger
      if (params.useFlightDate || rsvpLeg.flightDate) {
        params.pickupTimestamp = moment.tz(rsvpLeg.flightDate, 'MM/DD/YYYY hh:mmA', rsvpLeg.timezone).format('X')
      } else {
        params.pickupTimestamp = moment.tz(`${params.pickupDate} ${params.pickupTime}`, 'YYYY-MM-DD HH:mm', rsvpLeg.timezone).format('X')
        if (rsvpLeg.pickup.country === 'IND') {
          params.pickupTimestamp = moment().add(24, 'hours').format('X')
          if (!rsvpStore.gozoCabs.pickupTimeSet) params.dynamicTime = true
          // params.tripType = !rsvpStore.isRoundtrip ? 1 : 2
        }
      }
    }

    let discountCode = VueApp.$store.state.discountCode
    if (discountCode.code) {
      params.discountCode = discountCode.code
    } else {
      VueApp.$store.commit('discountCode/setDiscountData', {
        origPickup: rsvpStore.leg1.pickup.title,
        origDropoff: rsvpStore.leg1.dropoff.title
      })
    }

    // if (rsvpStore.lyft.enabled && !rsvpLeg.isAsap) {
    //   self.getLyftQuoteFuture(VueApp, params, callback)
    //   return
    // }

    VueApp.$store.commit('reservation/setQuoteLoading', true)
    let tmpLoading = {}
    tmpLoading[params.leg] = true
    VueApp.$store.commit('reservation/setQuoteLegLoadingData', tmpLoading)
    // VueApp.$store.commit('other/setOtherData', {quoteTime: moment()})
    let timeNow = moment()
    VueApp.$sdk.post(VueApp, quoteUrl, params, res => {
      self.sendQuoteTime(VueApp, timeNow, moment(), res.quoteId, params)
      VueApp.$store.commit('reservation/setQuoteLoading', false)

      if (res.lyft) {
        self.lyftResponse(VueApp, params, res, callback)
        return
      }

      let tmpLyft = {}
      tmpLyft[params.leg === 'leg1' ? 'enabled' : 'enabledLeg2'] = false

      let usa = ['us', 'usa', 'united states', 'united states of america']
      let canada = ['can', 'ca', 'canada']
      let ca = ['ca', 'california']
      if (res.error ||
        (
          res.geofences &&
          params.pickup.country && usa.indexOf(params.pickup.country.toLowerCase()) > -1 &&
          ca.indexOf(params.pickup.state.toLowerCase()) > -1 &&
          !res.geofences.servicearea.name.includes('LAX')
        ) ||
        (
          res.geofences &&
          params.pickup.country && usa.indexOf(params.pickup.country.toLowerCase()) > -1 &&
          ca.indexOf(params.pickup.state.toLowerCase()) === -1
        ) ||
        (!params.asap && params.pickup.country && canada.indexOf(params.pickup.country.toLowerCase()) > -1)
      ) {
        self.getLyftQuoteFuture(VueApp, params, callback)
        return
      }
      VueApp.$store.commit('reservation/setLyftData', tmpLyft)

      if (!res.error) {
        if (res.quoteId) {
          VueApp.$store.commit('reservation/setQuoteId', res.quoteId)
        }
        if (!params.isCharter) {
          let pickupInstructions = res.geofences.pickup.pickupInstructions
          if (pickupInstructions) {
            VueApp.$store.commit('instructions/setInstruction', {
              title: pickupInstructions.title,
              tnc: {
                text: pickupInstructions.tncText,
                img: pickupInstructions.tncImage,
                pickupLabel: pickupInstructions.upstairsLabel
              },
              tcp: {
                text: pickupInstructions.tcpText,
                img: pickupInstructions.tcpImage,
                pickupLabel: pickupInstructions.downstairsLabel
              }
            })
          }

          VueApp.$store.commit('reservation/setPickupGeofence', {
            leg: params.leg,
            id: res.geofences.pickup.id,
            airportCode: res.geofences.pickup.code || '',
            type: res.geofences.pickup.type
          })
          VueApp.$store.commit('reservation/setDropoffGeofence', {
            leg: params.leg,
            id: res.geofences.dropoff.id,
            airportCode: res.geofences.dropoff.code || '',
            type: res.geofences.dropoff.type
          })

          VueApp.$store.commit('reservation/setIsAirportPickup', { leg: params.leg, value: false })
          VueApp.$store.commit('reservation/setAirportCode', { leg: params.leg, code: '' })
          if (res.geofences.pickup.type === 'airport') {
            VueApp.$store.commit('reservation/setIsAirportPickup', { leg: params.leg, value: true })
            VueApp.$store.commit('reservation/setAirportCode', { leg: params.leg, code: res.geofences.pickup.code })
          }

          VueApp.$store.commit('reservation/setIsAirportDropoff', { leg: params.leg, value: false })
          if (res.geofences.dropoff.type === 'airport') {
            VueApp.$store.commit('reservation/setIsAirportDropoff', { leg: params.leg, value: true })
            if (res.geofences.pickup.type !== 'airport') {
              VueApp.$store.commit('reservation/setAirportCode', { leg: params.leg, code: res.geofences.dropoff.code })
            }
          }

          VueApp.$store.commit('reservation/setDistanceEta', {
            leg: params.leg,
            distance: res.route.distance,
            eta: res.route.eta.sec
          })
        } else {
          if (res.airport) {
            let pickupInstructions = res.airport.pickupInstructions
            if (pickupInstructions) {
              VueApp.$store.commit('instructions/setInstruction', {
                title: pickupInstructions.title,
                tnc: {
                  text: pickupInstructions.tncText,
                  img: pickupInstructions.tncImage,
                  pickupLabel: pickupInstructions.upstairsLabel
                },
                tcp: {
                  text: pickupInstructions.tcpText,
                  img: pickupInstructions.tcpImage,
                  pickupLabel: pickupInstructions.downstairsLabel
                }
              })
            }
          }
          VueApp.$store.commit('reservation/setCharterData', {
            airportGeoId: res.airport && res.airport.id ? res.airport.id : ''
          })
          VueApp.$store.commit('reservation/setPickupGeofence', {
            leg: params.leg,
            id: res.geofence.id,
            airportCode: res.airport && res.airport.id ? res.airport.id : '',
            type: res.airport && res.airport.id ? 'airport' : res.geofence.type
          })
          VueApp.$store.commit('reservation/setIsAirportPickup', {
            leg: params.leg,
            value: res.airport && res.airport.id !== ''
          })
          VueApp.$store.commit('reservation/setAirportCode', {
            leg: params.leg,
            code: res.airport && res.airport.id ? res.airport.airportCode : ''
          })
          VueApp.$store.commit('reservation/setDistanceEta', {
            leg: params.leg,
            distance: 0,
            eta: params.etaInSec
          })
        }

        tmpLoading = {}
        tmpLoading[params.leg] = false
        VueApp.$store.commit('reservation/setQuoteLegLoadingData', tmpLoading)

        let mtech = res.mtech
        VueApp.$store.commit('reservation/setMtechData', {enabled: typeof mtech === 'object'})

        let gozoCabs = false
        // let gozoCabs = res.gozoCabs
        // VueApp.$store.commit('reservation/setGozoCabsData', {enabled: typeof gozoCabs === 'object'})

        let services = {}
        if (!mtech && !gozoCabs) {
          res.services.forEach(service => {
            services['a' + service.serviceType.id] = self.buildServiceData(VueApp, service)
            if (service.settings.discountEnd) {
              VueApp.$store.commit('reservation/setDiscountTill', moment(service.settings.discountEnd, 'X').format('MM-DD-YYYY'))
              VueApp.$store.commit('reservation/setDiscountTillInUnix', service.settings.discountEnd)
            }
            if (service.unavailableTime && rsvpLeg.selectedService === `a${service.serviceType.id}`) {
              VueApp.$store.commit('reservation/setSelectedService', {
                leg: params.leg,
                value: ''
              })
              VueApp.$store.commit('setCurrentIndex', 0)
              VueApp.$store.commit('disablePreviousSteps', 3)
            }
          })
          let updateFareOnly = false
          if (discountCode.code && rsvpStore.leg1.pickup.title === discountCode.origPickup && rsvpStore.leg1.dropoff.title === discountCode.origDropoff) {
            updateFareOnly = true
          }
          if (updateFareOnly) {
            VueApp.$store.commit('reservation/updateServicePriceOnly', {
              leg: 'leg1',
              value: services
            })
            if (!Object.keys(rsvpStore.leg2.services).length) {
              VueApp.$store.commit('reservation/setServices', {
                leg: 'leg2',
                value: services
              })
            }
            VueApp.$store.commit('reservation/updateServicePriceOnly', {
              leg: 'leg2',
              value: services
            })
          } else {
            VueApp.$store.commit('reservation/setServices', {
              leg: params.leg,
              value: services
            })
          }
        } else if (gozoCabs) {
          // gozo cabs
        } else {
          mtech.services.forEach(service => {
            let product = service.product
            let info = service.info
            let price = service.price

            let hasDiscount = false
            let discountVal = 0
            let totalBeforeDc = 0
            let baseFare = price.amount
            service.price.breakdown.forEach(x => {
              if (x.description === 'Base rate') {
                baseFare = x.amount
              }
              if (x.description === 'Discount') {
                hasDiscount = true
                discountVal = x.amount
              }
              if (x.amount > 0) {
                totalBeforeDc += x.amount
              }
            })

            let addMarkup = 0
            if (mtech.markup.value) {
              addMarkup = mtechStore.markup.value
              if (mtech.markup.type === '%') {
                addMarkup = baseFare * (mtech.markup.value / 100)
              }
              addMarkup = parseFloat(addMarkup.toFixed(2))
            }

            let pax = { label: '', value: 1 }
            let luggage = { label: '', value: 0 }
            let cxl = ''
            let pircePax = ''
            let paxStandard = ''
            info.forEach(inf => {
              if (inf && inf.toLowerCase().indexOf('max passenger') > -1) {
                pax = {
                  label: inf,
                  value: parseInt(inf.split(' ')[inf.split(' ').length - 1]) || 1
                }
              }
              if (inf && inf.toLowerCase().indexOf('max bag') > -1) {
                luggage = {
                  label: inf,
                  value: parseInt(inf.split(' ')[inf.split(' ').length - 1]) || 1
                }
              }
              if (inf && inf.toLowerCase().indexOf('24 hour cancelation') > -1) {
                cxl = inf
              }
              if (inf && inf.toLowerCase().indexOf('price includes all') > -1) {
                pircePax = inf
              }
              if (inf && inf.toLowerCase().indexOf('1 standard checked bag & 1 personal') > -1) {
                paxStandard = inf
              }
            })
            services[service.product.code] = {
              uid: product.uid,
              category: product.category,
              code: product.code,
              desc: product.description,
              img: product.image,
              name: product.name,
              maxPax: pax.label,
              maxPaxVal: pax.value,
              maxLuggage: luggage.label,
              maxLuggageVal: luggage.value,
              cancellation: cxl,
              pricePax: pircePax,
              paxStandard: paxStandard,
              price: {
                baseFare: baseFare,
                amount: price.amount,
                addMarkup: addMarkup,
                breakdown: price.breakdown,
                hasDiscount: hasDiscount,
                discountVal: Math.abs(discountVal),
                totalBeforeDc: totalBeforeDc
              },
              pickupTimes: service.pickupTimes,
              product: product
            }
          })
          VueApp.$store.commit('reservation/setIsAsap', {leg: params.leg, value: false})
          VueApp.$store.commit('reservation/setMtechLegData', {
            leg: params.leg,
            fields: { services: services }
          })
          if (!rsvpLeg.pickupType) {
            VueApp.$store.commit('reservation/setPickupType', { leg: params.leg, type: 'Curbside', fee: 0 })
          }

          let serviceExist = false
          mtech.services.forEach(service => {
            if (service.product.code === rsvpLeg.selectedService) {
              serviceExist = true
            }
          })
          if (!serviceExist) {
            VueApp.$store.commit('reservation/setSelectedService', {
              leg: params.leg,
              value: ''
            })
            VueApp.$store.commit('setCurrentIndex', 0)
            VueApp.$store.commit('disablePreviousSteps', 3)
          }
        }

        VueApp.$nextTick(function () {
          VueApp.$forceUpdate()
        })
      } else {
        VueApp.$store.commit('reservation/setMtechLegData', {
          leg: params.leg,
          fields: { services: {} }
        })
        VueApp.$store.commit('reservation/setSelectedService', {
          leg: params.leg,
          value: ''
        })
        VueApp.$store.commit('setCurrentIndex', 0)
        VueApp.$store.commit('disablePreviousSteps', 3)
      }
      setTimeout(function () {
        callback(res)
      }, 300)
    }, '2.0')
  },
  lyftResponse (VueApp, params, res, callback) {
    // let self = this
    let rsvpStore = VueApp.$store.state.reservation
    let rsvpLeg = rsvpStore[params.leg]
    if (res.errors && res.errors.length || !res.lyft.length) {
      VueApp.$store.commit('reservation/setMtechLegData', {
        leg: params.leg,
        fields: { services: {} }
      })
      VueApp.$store.commit('reservation/setServices', {
        leg: params.leg,
        value: {}
      })
      VueApp.$store.commit('reservation/setSelectedService', {
        leg: params.leg,
        value: ''
      })
      VueApp.$store.commit('setCurrentIndex', 0)
      VueApp.$store.commit('disablePreviousSteps', 3)
      res.error = {
        message: VueApp.$t('searchForm.sorryService')
      }
    } else {
      let services = {}
      let serviceExist = false
      res.lyft.forEach(x => {
        if (!x.can_request_ride) return
        if (rsvpLeg.selectedService === `a${x.ride_type}`) serviceExist = true
        let price = (x.estimated_cost_cents_max / 100).toFixed(2)
        let maxPax = x.price_explanation_text ? x.price_explanation_text.replace(/^\D+/g, '') : 4
        if (maxPax) maxPax = parseInt(maxPax)
        if (!maxPax) maxPax = 4
        let pricesArray = [{
          discount: 0,
          distance: x.estimated_distance_miles,
          original: parseFloat(price),
          price: parseFloat(price),
          passengers: 1
        }]
        for (var c = 1; c < maxPax; c++) {
          pricesArray.push(pricesArray[0])
        }
        services[`a${x.ride_type}`] = {
          id: x.ride_type,
          code: 'a' + x.ride_type,
          brandedName: x.display_name,
          maxLuggage: maxPax,
          maxPassengers: maxPax,
          curbside: false,
          meetAndGreet: false,
          pickupFee: 0,
          prices: pricesArray,
          roundtrip: [],
          isShared: false,
          status: 'allowed',
          img: x.custom_image,
          imgInactive: x.custom_image,
          airportFee: 0,
          excerpt: '',
          description: '',
          advantage: '',
          stops: 0,
          licenseType: '',
          travelInsurance: 0,
          availabilityInfo: false,
          category: '',
          defaultTip: 0,
          gasFee: 0,
          moreImgs: '',
          optinAllow: false,
          optinPercent: 1,
          unavailableTime: false,
          bufferTime: 0,
          ride_type: x.ride_type,
          cost_token: x.cost_token,
          driver_availability_token: x.driver_availability_token || ''
        }
      })
      if (!Object.keys(services).length) res.lyft = []
      if (!serviceExist) {
        VueApp.$store.commit('reservation/setSelectedService', {
          leg: params.leg,
          value: ''
        })
        VueApp.$store.commit('setCurrentIndex', 0)
        VueApp.$store.commit('disablePreviousSteps', 3)
      }
      VueApp.$store.commit('reservation/setServices', {
        leg: params.leg,
        value: services
      })
      VueApp.$store.commit('reservation/setDistanceEta', {
        leg: params.leg,
        distance: res.route.distance,
        eta: res.route.eta.sec
      })
    }

    let tmpLoading = {}
    tmpLoading[params.leg] = false
    VueApp.$store.commit('reservation/setQuoteLegLoadingData', tmpLoading)
    setTimeout(function () {
      callback(res)
    }, 300)
  },
  getLyftQuoteFuture (VueApp, params, callback) {
    let self = this
    let rsvpStore = VueApp.$store.state.reservation
    let rsvpLeg = rsvpStore[params.leg]

    let newParam = {
      brandId: params.brandId,
      pickup: params.pickup,
      dropoff: params.dropoff,
      pickupTime: moment(rsvpLeg.pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(VueApp, false)).format('X'),
      leg: params.leg
    }
    let timeNow = moment()
    VueApp.$sdk.post(VueApp, '/quotation/lyft/future', newParam, res => {
      self.sendQuoteTime(VueApp, timeNow, moment(), res.quoteId, params)
      let tmpLyft = {}
      if (res.error) {
        tmpLyft[params.leg === 'leg1' ? 'enabled' : 'enabledLeg2'] = false
        VueApp.$store.commit('reservation/setLyftData', tmpLyft)

        VueApp.$store.commit('reservation/setMtechLegData', {
          leg: params.leg,
          fields: { services: {} }
        })
        VueApp.$store.commit('reservation/setServices', {
          leg: params.leg,
          value: {}
        })
        VueApp.$store.commit('reservation/setSelectedService', {
          leg: params.leg,
          value: ''
        })
        VueApp.$store.commit('setCurrentIndex', 0)
        VueApp.$store.commit('disablePreviousSteps', 3)

        let tmpLoading = {}
        tmpLoading[params.leg] = false
        VueApp.$store.commit('reservation/setQuoteLegLoadingData', tmpLoading)
      } else {
        tmpLyft[params.leg === 'leg1' ? 'enabled' : 'enabledLeg2'] = res.hasOwnProperty('lyft')
        VueApp.$store.commit('reservation/setLyftData', tmpLyft)

        self.lyftResponse(VueApp, newParam, res, callback)
        VueApp.$store.commit('reservation/setServiceLoading', false)
      }
    }, '2.0')
  },
  getQuote (VueApp, params, callback) {
    let self = this

    let brands = Object.keys(CONFIG.Brands)
    let brandId = VueApp.$store.state.brandId
    let index = Object.values(CONFIG.Brands).findIndex(x => x.id === brandId)
    if (CONFIG.Brands[brands[index]].code === 'pts') {
      params.hudson = true
    }
    // params.hudson = true

    VueApp.$sdk.post(VueApp, '/reservations/' + params.date, params, res => {
      if (!res.error) {
        VueApp.$store.commit('reservation/setPickupGeofence', {
          leg: params.leg,
          id: res.geofences.pickup.id,
          airportCode: res.geofences.pickup.airportCode,
          type: res.geofences.pickup.type
        })
        VueApp.$store.commit('reservation/setDropoffGeofence', {
          leg: params.leg,
          id: res.geofences.dropoff.id,
          airportCode: res.geofences.dropoff.airportCode,
          type: res.geofences.dropoff.type
        })

        VueApp.$store.commit('reservation/setIsAirportPickup', { leg: params.leg, value: false })
        VueApp.$store.commit('reservation/setAirportCode', { leg: params.leg, code: '' })
        if (res.geofences.pickup.type === 'airport') {
          VueApp.$store.commit('reservation/setIsAirportPickup', { leg: params.leg, value: true })
          VueApp.$store.commit('reservation/setAirportCode', { leg: params.leg, code: res.geofences.pickup.airportCode })
        }

        VueApp.$store.commit('reservation/setIsAirportDropoff', { leg: params.leg, value: false })
        if (res.geofences.dropoff.type === 'airport') {
          VueApp.$store.commit('reservation/setIsAirportDropoff', { leg: params.leg, value: true })
          if (res.geofences.pickup.type !== 'airport') {
            VueApp.$store.commit('reservation/setAirportCode', { leg: params.leg, code: res.geofences.dropoff.airportCode })
          }
        }

        VueApp.$store.commit('reservation/setDistanceEta', {
          leg: params.leg,
          distance: res.route.distance,
          eta: res.route.eta.sec
        })

        let services = res.services
        let rsvpStore = VueApp.$store.state.reservation
        if (rsvpStore[params.leg].isAirportPickup && rsvpStore.sharedAllowedTime.start === rsvpStore.sharedAllowedTime.end) {
          services.Shared.status = 'restricted'
        }
        VueApp.$store.commit('reservation/setServices', {
          leg: params.leg,
          value: {
            shared: self.buildServiceData(VueApp, services.Shared),
            opoli: self.buildServiceData(VueApp, services.Opoli),
            black: self.buildServiceData(VueApp, services.Black),
            suv: self.buildServiceData(VueApp, services.SUV),
            shuttle: self.buildServiceData(VueApp, services['Private Shuttle'])
          }
        })

        let geoPricing = res.geofences.pricing
        VueApp.$store.commit('reservation/setDiscountTill', moment(geoPricing.promotionEndDate, 'YYYY-MM-DD').add('1', 'days').format('MM-DD-YYYY'))
        VueApp.$store.commit('reservation/setHoliday', {
          date: geoPricing.holidayDate,
          shared: {
            currency: geoPricing.pricing.SharedHolidayRateCurrency,
            value: geoPricing.pricing.SharedHolidayRate
          },
          opoli: {
            currency: geoPricing.pricing.OpoliHolidayRateCurrency,
            value: geoPricing.pricing.OpoliHolidayRate
          },
          black: {
            currency: geoPricing.pricing.BlackHolidayRateCurrency,
            value: geoPricing.pricing.BlackHolidayRate
          },
          suv: {
            currency: geoPricing.pricing.SUVHolidayRateCurrency,
            value: geoPricing.pricing.SUVHolidayRate
          },
          shuttle: {
            currency: geoPricing.pricing.PrivateShuttleHolidayRateCurrency,
            value: geoPricing.pricing.PrivateShuttleHolidayRate
          }
        })
      }

      callback(res)
    })
  },
  buildServiceData (VueApp, data) {
    let charter = VueApp.$store.state.reservation.charter
    let oneway = []
    let roundtrip = []
    if (!charter.enabled) {
      let dcEnabled = data.settings.discountWidget
      for (let i = 0; i < data.serviceType.maxPassengers; i++) {
        data.oneway[i].price = parseFloat(dcEnabled ? data.oneway[i].price : data.oneway[i].original)
        data.oneway[i].original = parseFloat(data.oneway[i].original)
        data.roundtrip[i].price = parseFloat(dcEnabled ? data.roundtrip[i].price : data.roundtrip[i].original)
        data.roundtrip[i].original = parseFloat(data.roundtrip[i].original)
        if (!dcEnabled) {
          data.oneway[i].discount = 0
          data.roundtrip[i].discount = 0
        }
        oneway.push(data.oneway[i])
        roundtrip.push(data.roundtrip[i])
      }
    } else {
      for (let i = 0; i < data.serviceType.maxPassengers; i++) {
        oneway.push(data.fare)
      }
    }

    let curbside = false
    let meetAndGreet = false
    let meetAndGreetFee = 0

    let curbsideIndex = data.pickupTypes.findIndex(x => x.name === 'Curbside')
    if (curbsideIndex > -1 && data.pickupTypes[curbsideIndex].enabled) {
      curbside = true
    }

    let meetAndGreetIndex = data.pickupTypes.findIndex(x => x.name === 'MeetAndGreet')
    if (meetAndGreetIndex > -1 && data.pickupTypes[meetAndGreetIndex].enabled) {
      meetAndGreet = true
      meetAndGreetFee = data.pickupTypes[meetAndGreetIndex].fee
    }

    let availabilityInfo = false
    if (data.serviceType.useShifts) {
      availabilityInfo = data.availability
    }

    let category = data.serviceType.category
    // if (CONFIG.featureToggle.oldServiceUI.indexOf(VueApp.$store.state.brandId) > -1 ||
    //   ([4].indexOf(VueApp.$store.state.brandId) > -1 && data.serviceType.id === 24)
    // ) {
    //   category = ''
    // }
    let bufferTime = data.serviceType.bufferWidgetMins
    if (!data.serviceType.bufferWidgetMins && VueApp.$store.state.reservation.webTimeBuffer) {
      bufferTime = VueApp.$store.state.reservation.webTimeBuffer
    }
    return {
      id: data.serviceType.id,
      code: 'a' + data.serviceType.id,
      brandedName: data.serviceType.name,
      maxLuggage: data.serviceType.maxLuggages,
      maxPassengers: data.serviceType.maxPassengers,
      curbside: curbside,
      meetAndGreet: meetAndGreet,
      pickupFee: meetAndGreetFee,
      prices: oneway,
      roundtrip: roundtrip,
      isShared: data.serviceType.isShared,
      status: 'allowed',
      img: data.serviceType.image,
      airportFee: data.settings.airportFee,
      excerpt: data.serviceType.excerptWeb,
      description: data.serviceType.descriptionWeb,
      advantage: data.serviceType.advantageWeb,
      stops: data.serviceType.stops,
      licenseType: data.serviceType.licenseType,
      travelInsurance: data.settings.travelInsurance || 0,
      availabilityInfo: availabilityInfo,
      category: category,
      defaultTip: data.serviceType.defaultTip,
      gasFee: data.settings.gasFee || 0,
      moreImgs: data.serviceType.images,
      optinAllow: data.serviceType.optinAllow,
      optinPercent: data.serviceType.optinPercent || 1,
      unavailableTime: data.unavailableTime,
      bufferTime: bufferTime,
      portalFee: data.settings.portalFee || 0,
      portalFeeType: data.settings.portalFeeType || '%'
    }
  },
  sendQuoteTime (VueApp, start, end, quoteId, param) {
    let store = VueApp.$store.state
    let duration = end.diff(start, 'milliseconds') / 1000
    VueApp.$sdk.opt('/quotation/time', {
      token: store.user.token,
      brandId: store.brandId,
      quotationId: quoteId,
      responseTime: duration,
      deviceType: 'ww',
      data: JSON.stringify(param)
    }, res => {
      if (res.error) console.log('ERROR quotation time')
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/quote.js